import React from 'react';
import '../../assets/styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="app-footer">
      <div className="copyright">
        <p>&copy; {currentYear} AI Maths Tutor</p>
      </div>
    </footer>
  );
};

export default Footer;